module.exports = __webpack_public_path__ + "static/media/abonds_c.88e3ff93.png";